<template>
  <div
    v-if="userData"
    ref="header"
    class="main-header"
  >
    <img
      v-if="hasLogo"
      ref="logo"
      class="main-header-logo"
      :src="userData.clientLogo"
      alt="company logo"
    >
    <div class="main-header-wrapper">
      <div class="main-header-company-and-user">
        <div
          ref="companyName"
          class="main-header-company"
        >
          {{ userData.company }}
        </div>
        <div class="main-header-user">
          <!--			<img ref="thumbImage" class="main-header-user-image" :src="imageHead" alt="user image" />-->
          <span
            ref="nameField"
            class="user-name"
          >{{ userData.firstName }} {{ userData.lastName }}</span>
          <a class="logout-link" v-if="isSandbox" @click="returnToSandbox">Return to Sandbox</a>
          <a class="logout-link" v-else @click="logout">Logout</a>
        </div>
      </div>
      <svg class="mobile-logout" @click="mobileLogout" style="cursor: pointer;" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 20 20">
        <g id="logout" transform="translate(0 0)">
          <path
            d="M13 2.5H5.5a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1H13"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
      
          <path
            d="M9.5 10h7"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
      
          <path
            d="M14.5 7l3 3-3 3"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import ColorsMixin from "@/mixins/ColorsMixin";
import UtilsMixin from "@/mixins/UtilsMixin"

export default {
	name: "BrHeader",
  components:{},
  mixins:[UtilsMixin, ColorsMixin],
	data() {
		return {
			userData: null,
			imageHead: "/img/blankman.png",
			showMenu: true,
		}
	},
	computed:{
    styles() {
        if(this.userData?.client_styles) return JSON.parse(this.userData.client_styles)
        return null
    },
		hasLogo(){
			if(this.userData){
				return this.userData.clientLogo && this.userData.clientLogo !== "";
			}
			return false;
		},
    isSandbox() {
      return window.location.origin.toLowerCase() === "https://sandboxrewards.visionlink.co"
    },
	},
	watch: {
		styles: {
			handler: function() {
				this.updateClientColors()
			},
			deep: true
		},
	},
	mounted() {
		this.$dataDirectory.checkLogin(
			() => this.dataAvailable(),
			() => this.dataNotLoaded()
		);
		this.userData = this.$dataDirectory.userData;

		this.$nextTick(() => {
			this.updateClientColors()
		})
	},
	methods: {
		dataAvailable(){
			this.userData = this.$dataDirectory.userData;
			// setTimeout(() => this.positionImage(), 2);
			// setTimeout(() => this.positionMenu(), 2);
			//calls init so page data updates correctly from a refresh
			if(this.$parent
				&& this.$parent.$refs
				&& this.$parent.$refs.page
				&& this.$parent.$refs.page.init){
				this.$parent.$refs.page.init();
			}
			this.imageHead = this.userData.smallImage !== "" ? this.userData.smallImage : "/img/blankman.png";
		},
		dataNotLoaded(){
			this.$router.push("/login");
		},
    mobileLogout() {
      if (this.isSandbox) this.returnToSandbox();
      else this.logout();
    },
		logout(){
			this.$apiManager.post("logout", {}).then(
				() => this.logoutProceed(),
				() => this.logoutProceed(),
			);
		},
		logoutProceed(){
			this.$apiManager.token = null;
			this.$apiManager.adminUrl = null;
			this.$dataDirectory.userData = {
				env_code: "",
				employee_id: 0,
				client_id: 0,
				firstName: "",
				lastName: "",
				image: "https://via.placeholder.com/500",
				smallImage: "https://via.placeholder.com/100",
				clientLogo: "https://via.placeholder.com/75x30",
				company: "",
				position: "",
				username: "",
				email:"",
				success: false
			};
			this.$router.push("/login");
		},
		updateClientColors() {
      // TODO: this needs to be redone, it would be good to use something like Pinia or Vuex to manage this...
			if(this.styles) {
        let highlight = this.getHighlightColor();

        let root_element = document.querySelector(':root')
        root_element.style.setProperty('--highlight-color', highlight)

        let tint = 0.8

        let brandColor = this.getBrandColor();
        let brandColorTint = this.getBrandTintColor(tint);

        root_element.style.setProperty('--brand-color', brandColor)
        root_element.style.setProperty('--brand-color-tint', brandColorTint)

        let foregroundColor = this.getForegroundColor();

        root_element.style.setProperty('--foreground-color', foregroundColor)
			}
		},
    returnToSandbox() {
      // close tab
      window.close();
    }
	}
}
</script>

<style lang="scss" scoped>
    @use '../scss/_variables.scss';

	.main-header{
		background-color: var(--brand-color);
		color: var(--foreground-color);
		min-height: variables.$header-height;
		position: fixed;
    display: flex;
    align-items: center;
		width: 100vw;
		z-index: 1000;
    &-wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 13px 22px;
      gap: 8px;
    }
    &-company-and-user {
      display: flex;
      justify-content: space-between;
      width: 100%;
      @media screen and (max-width: 600px) {
        flex-direction: column;
        text-align: right;
      }
    }
		&-user{
      color: var(--foreground-color);
      display: flex;
      flex-direction: column;
      text-align: right;
      align-items: flex-end;
			&-image{
				border-radius: 50%;
				max-width: 100px;
				position: absolute;
				right: 90px;
				top: -8px;
			}
		}
		&-logo{
      height: 60px;
      width: 110px;
      float: left;
      object-fit: contain;
		}
		&-company{
			display: inline-block;
		}
	}
  a {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  @media screen and (max-width: 600px) {
    .logout-link {
      display: none;
    }
  }

  @media screen and (min-width: 601px) {
    .mobile-logout {
      display: none;
    }
  }
</style>
